import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/sandbox/page.tsx");
